import {combineReducers} from 'redux'
import {
    LINKS_LOADED,
    TICKET_STREAM_LOADED,
    TICKET_STREAM_QUERIED,
    MINOR_TICKET_STREAM_QUERIED,
    TICKET_LOADED,
    TICKET_CREATED,
    CRITERIA_UPDATED,
    EXPORT_XLSX_TICKETS_OPTION_UPDATED,
    EXPORT_PDF_TICKETS_OPTION_UPDATED,
    REPORT_PDF_TICKETS_OPTION_UPDATED,
    CORRECT_TICKET_INFORMATIONS_CMD_RESET,
    CORRECT_LOCATION_REFERENCE_CMD_UPDATED,
    CORRECT_LOCATION_REFERENCE_CMD_SENT,
    CORRECT_LOCATION_REFERENCE_CMD_RESET,
    CORRECT_CALLER_CMD_UPDATED,
    OPEN_TICKET_CMD_UPDATED,
    OPEN_TICKET_CMD_RESET,
    IDENTIFY_ASSIGNEE_CMD_UPDATED,
    REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED,
    DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED,
    REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED,
    SCHEDULE_INTERVENTION_CMD_UPDATED,
    START_INTERVENTION_CMD_UPDATED,
    FINISH_INTERVENTION_CMD_UPDATED,
    ADD_MESSAGE_CMD_UPDATED,
    CLOSE_TICKET_CMD_UPDATED,
    CORRECT_TICKET_INFORMATIONS_CMD_UPDATED,
    CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED,
    RECEIVE_CALL_CMD_UPDATED,
    EMIT_CALL_TO_CMD_UPDATED,
    FINISH_MISSION_CMD_UPDATED,
    OPEN_TICKET_CMD_SENT,
    IDENTIFY_ASSIGNEE_CMD_SENT,
    REPORT_SENDING_SERVICE_ORDER_CMD_SENT,
    DEFINE_INTERVENTION_DEADLINE_CMD_SENT,
    REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT,
    SCHEDULE_INTERVENTION_CMD_SENT,
    START_INTERVENTION_CMD_SENT,
    FINISH_INTERVENTION_CMD_SENT,
    ADD_MESSAGE_CMD_SENT,
    CLOSE_TICKET_CMD_SENT,
    CORRECT_TICKET_INFORMATIONS_CMD_SENT,
    CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT,
    RECEIVE_CALL_CMD_SENT,
    EMIT_CALL_TO_CMD_SENT,
    FINISH_MISSION_CMD_SENT,
    ACCEPT_INTERVENTION_CMD_SENT,
    ACCEPT_INTERVENTION_CMD_UPDATED,
    ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL, CORRECT_OTP,
} from './actions'

function ticket(state = null, action) {
    switch (action.type) {
        case TICKET_LOADED:
            return action.ticket
        case TICKET_CREATED:
            return action.ticket
        default:
            return state
    }
}

function stream(state = [], action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function aggregations(state = null, action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
            return action.aggregations
        default:
            return state
    }
}

function range(state = null, action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function query(state = null, action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function stats(state = null, action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
            return action.stats
        default:
            return state
    }
}

function _links(state = [], action) {
    switch (action.type) {
        case TICKET_STREAM_LOADED:
        case TICKET_STREAM_QUERIED:
        case LINKS_LOADED:
            return action._links
        default:
            return state
    }
}

function criteria(state = null, action) {
    switch (action.type) {
        case CRITERIA_UPDATED:
            return {...state, ...action.criteria}
        default:
            return state
    }
}

function minorStream(state = [], action) {
    switch (action.type) {
        case MINOR_TICKET_STREAM_QUERIED:
            return action.stream
        default:
            return state
    }
}

function minorRange(state = null, action) {
    switch (action.type) {
        case MINOR_TICKET_STREAM_QUERIED:
            return action.range
        default:
            return state
    }
}

function minorQuery(state = null, action) {
    switch (action.type) {
        case MINOR_TICKET_STREAM_QUERIED:
            return action.query
        default:
            return state
    }
}

function exportXlsxTicketsOption(state = null, action) {
    switch (action.type) {
        case EXPORT_XLSX_TICKETS_OPTION_UPDATED:
            return {...state, ...action.option}
        default:
            return state
    }
}

function exportPdfTicketsOption(state = null, action) {
    switch (action.type) {
        case EXPORT_PDF_TICKETS_OPTION_UPDATED:
            return {...state, ...action.option}
        default:
            return state
    }
}

function reportPdfTicketsOption(state = null, action) {
    switch (action.type) {
        case REPORT_PDF_TICKETS_OPTION_UPDATED:
            return {...state, ...action.option}
        default:
            return state
    }
}

function openTicketCmd(state = null, action) {
    switch (action.type) {
        case OPEN_TICKET_CMD_UPDATED:
            return {...state, ...action.cmd}
        case OPEN_TICKET_CMD_SENT:
        case OPEN_TICKET_CMD_RESET:
            return null
        default:
            return state
    }
}

function correctLocationReferenceCmd(state = null, action) {
    switch (action.type) {
        case CORRECT_LOCATION_REFERENCE_CMD_UPDATED:
            return {...state, ...action.cmd}
        case CORRECT_LOCATION_REFERENCE_CMD_SENT:
        case CORRECT_LOCATION_REFERENCE_CMD_RESET:
            return null
        default:
            return state
    }
}

function correctCallerCmdReducers(state = null, action) {
    switch (action.type) {
        case CORRECT_CALLER_CMD_UPDATED:
            return {...state, ...action.cmd}
        default:
            return state
    }
}

function identifyAssigneeCmd(state = null, action) {
    switch (action.type) {
        case IDENTIFY_ASSIGNEE_CMD_UPDATED:
            return {...state, ...action.cmd}
        case IDENTIFY_ASSIGNEE_CMD_SENT:
            return null
        default:
            return state
    }
}

function reportSendingServiceOrderCmd(state = null, action) {
    switch (action.type) {
        case REPORT_SENDING_SERVICE_ORDER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REPORT_SENDING_SERVICE_ORDER_CMD_SENT:
            return null
        default:
            return state
    }
}

function defineInterventionDeadlineCmd(state = null, action) {
    switch (action.type) {
        case DEFINE_INTERVENTION_DEADLINE_CMD_UPDATED:
            return {...state, ...action.cmd}
        case DEFINE_INTERVENTION_DEADLINE_CMD_SENT:
            return null
        default:
            return state
    }
}

function reportFormalNoticeForProviderCmd(state = null, action) {
    switch (action.type) {
        case REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_UPDATED:
            return {...state, ...action.cmd}
        case REPORT_FORMAL_NOTICE_FOR_PROVIDER_CMD_SENT:
            return null
        default:
            return state
    }
}

function scheduleInterventionCmd(state = null, action) {
    switch (action.type) {
        case SCHEDULE_INTERVENTION_CMD_UPDATED:
            return {...state, ...action.cmd}
        case SCHEDULE_INTERVENTION_CMD_SENT:
            return null
        default:
            return state
    }
}

function startInterventionCmd(state = null, action) {
    switch (action.type) {
        case START_INTERVENTION_CMD_UPDATED:
            return {...state, ...action.cmd}
        case START_INTERVENTION_CMD_SENT:
            return null
        default:
            return state
    }
}

function finishInterventionCmd(state = null, action) {
    switch (action.type) {
        case FINISH_INTERVENTION_CMD_UPDATED:
            return {...state, ...action.cmd}
        case FINISH_INTERVENTION_CMD_SENT:
            return null
        default:
            return state
    }
}

function addMessageCmd(state = null, action) {
    switch (action.type) {
        case ADD_MESSAGE_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ADD_MESSAGE_CMD_SENT:
            return null
        default:
            return state
    }
}

function closeTicketCmd(state = null, action) {
    switch (action.type) {
        case CLOSE_TICKET_CMD_UPDATED:
            return {...state, ...action.cmd}
        case CLOSE_TICKET_CMD_SENT:
            return null
        default:
            return state
    }
}

function correctTicketInformationsCmd(state = null, action) {
    switch (action.type) {
        case CORRECT_TICKET_INFORMATIONS_CMD_UPDATED:
            return {...state, ...action.cmd}
        case CORRECT_TICKET_INFORMATIONS_CMD_SENT:
        case CORRECT_TICKET_INFORMATIONS_CMD_RESET:
            return null
        default:
            return state
    }
}

function correctTicketEventInformationsCmd(state = null, action) {
    switch (action.type) {
        case CORRECT_TICKET_EVENT_INFORMATIONS_CMD_UPDATED:
            return {...state, ...action.cmd}
        case CORRECT_TICKET_EVENT_INFORMATIONS_CMD_SENT:
            return null
        default:
            return state
    }
}

function receiveCallCmd(state = null, action) {
    switch (action.type) {
        case RECEIVE_CALL_CMD_UPDATED:
            return {...state, ...action.cmd}
        case RECEIVE_CALL_CMD_SENT:
            return null
        default:
            return state
    }
}

function emitCallToCmd(state = null, action) {
    switch (action.type) {
        case EMIT_CALL_TO_CMD_UPDATED:
            return {...state, ...action.cmd}
        case EMIT_CALL_TO_CMD_SENT:
            return null
        default:
            return state
    }
}

function finishMissionCmd(state = null, action) {
    switch (action.type) {
        case FINISH_MISSION_CMD_UPDATED:
            return {...state, ...action.cmd}
        case FINISH_MISSION_CMD_SENT:
            return null
        default:
            return state
    }
}

function acceptInterventionCmd(state = { otherEmails: []}, action) {
    switch (action.type) {
        case ACCEPT_INTERVENTION_CMD_UPDATED:
            return {...state, ...action.cmd}
        case ACCEPT_INTERVENTION_CMD_UPDATED_EMAIL:
            const {otherEmails} = action
            return {...state, otherEmails}
        case ACCEPT_INTERVENTION_CMD_SENT:
            return {otherEmails: []}
        default:
            return state
    }
}

function cmdCorrectOTP(state = {}, action) {
    switch (action.type) {
        case CORRECT_OTP:
            if (action.cmd) {
                const {otp, operation} = action.cmd
                switch (operation) {
                    case 'Add':
                        return {...state, value: otp}
                    case 'Remove':
                        return {...state, value: undefined, qualification: undefined}
                }
            }
            return {...state, ...action.cmd}
    }
    return state
}

export default combineReducers({
    ticket,
    stream,
    aggregations,
    range,
    query,
    stats,
    _links,
    criteria,
    minorStream,
    minorRange,
    minorQuery,
    exportXlsxTicketsOption,
    exportPdfTicketsOption,
    reportPdfTicketsOption,
    openTicketCmd,
    identifyAssigneeCmd,
    reportSendingServiceOrderCmd,
    defineInterventionDeadlineCmd,
    reportFormalNoticeForProviderCmd,
    scheduleInterventionCmd,
    startInterventionCmd,
    finishInterventionCmd,
    addMessageCmd,
    closeTicketCmd,
    correctTicketInformationsCmd,
    correctTicketEventInformationsCmd,
    receiveCallCmd,
    emitCallToCmd,
    finishMissionCmd,
    correctLocationReferenceCmd,
    acceptInterventionCmd,
    correctCallerCmdUpdate: correctCallerCmdReducers,
    cmdCorrectOTP
})




// WEBPACK FOOTER //
// ./lib/ticket/reducers.js